import { Product } from "@/types/general";
import BaseButton from "@reusables/BaseButton";
import BaseModal from "@reusables/Modals/BaseModal";
import { useUpdateProductWebStatusMutation } from "@redux/features/products/productsApi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { toastError } from "@helpers/utils";

type WebStatusConfirmationModalProps = {
    isOpen: boolean;
    product?: Product.Root;
    nextValue?: boolean;
    onClose: () => void;
    onSuccess?: (value: boolean) => void;
};

export default function WebStatusConfirmationModal(props: WebStatusConfirmationModalProps) {
    const { t } = useTranslation("", { keyPrefix: "products.viewEditProduct.modals.webProduct" });

    const [updateProductWebStatus, { isLoading }] = useUpdateProductWebStatusMutation();

    const isEnabling = Boolean(props.nextValue);

    return (
        <BaseModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            width={700}
            padding="56px"
            isLoading={isLoading}
        >
            <div className="space-y-[32px]">
                <div className="text-xl font-semibold text-center text-accent">{t("heading")}</div>
                <div className="text-center text-accent">
                    {isEnabling ? t("enableSubheading") : t("disableSubheading")}{" "}
                    <span className="bold-highlight">{props.product?.name}?</span>
                </div>
                <div className="grid grid-cols-2 gap-[16px]">
                    <BaseButton
                        text={t("buttons.cancel")}
                        size="md"
                        primaryOutlined
                        onClick={props.onClose}
                    />
                    <BaseButton
                        text={isEnabling ? t("buttons.enable") : t("buttons.disable")}
                        size="md"
                        onClick={() => {
                            if (props.product && typeof props.nextValue === "boolean") {
                                updateProductWebStatus({
                                    id: props.product.id,
                                    is_web_product: props.nextValue,
                                })
                                    .unwrap()
                                    .then(() => {
                                        props.onSuccess?.(props.nextValue as boolean);
                                        toast.success(t("responses.success"));
                                    })
                                    .catch((error) => {
                                        toastError(error);
                                    })
                                    .finally(() => {
                                        props.onClose();
                                    });
                            }
                        }}
                    />
                </div>
            </div>
        </BaseModal>
    );
}
